import React from 'react';
import './PopupModal.css';

const PopupModal = ({
    isOpen,
    data,
    onClose,
    onConfirm,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    children, // <-- allow custom content
    zIndex = 1000 // <-- allow custom z-index for stacking
}) => {
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" style={{ zIndex }}>
            <div className="custom-modal-box">
                {data.title && <h2 className="custom-modal-title">{data.title}</h2>}
                <div className="custom-modal-content">
                    {/* Render children if provided, otherwise fallback to text */}
                    {children ? children : <p>{data.text}</p>}
                </div>
                <div className="custom-modal-footer">
                    {/* If there's no confirm action, show only a close button */}
                    {!onConfirm ? (
                        <button onClick={onClose} className="custom-confirm-btn">
                            {"Close"}
                        </button>
                    ) : (
                        <>
                            <button onClick={onClose} className="custom-close-btn">
                                {cancelLabel}
                            </button>
                            <button onClick={onConfirm} className="custom-confirm-btn">
                                {confirmLabel}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PopupModal;